"use client";

import { trimbleAuthBackend } from "./trimble/index";
import type { AuthBackend } from "./types";

/** For non-React callers. */
export function getAuthBackend(): AuthBackend {
  return trimbleAuthBackend;
}

/** For React components. */
export function useAuthBackend(): AuthBackend {
  return trimbleAuthBackend;
}
